import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { DataService } from "../services/data.service";
import { AosService } from "../services/aos.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    lastRequestTime = new Date();
    isActive = false;

    constructor(
        private router: Router, 
        private dataService: DataService,
        private aosService: AosService) {
        
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        if (sessionStorage.getItem('aos_value') != null) {
            
            let clonedReq = null;
            if(req.headers.has('AOS')){
                clonedReq = req.clone({
                    headers: new HttpHeaders({
                        'Authorization': 'Bearer ' + atob(sessionStorage.getItem('aos_value'))
                    })
                });
                
            }
            
            return next.handle(clonedReq).pipe(
                tap(
                    succ => { 
                        this.lastRequestTime = new Date();
                    },
                    err => {
                        if (err.status == 401){
                            sessionStorage.removeItem('aos_value');
                            // this.router.navigateByUrl('/sign-in');
                            this.aosService.LoginPartnerUser();
                        }
                    }
                )
            )
        }
        else
            return next.handle(req.clone());
    }
}